import { createAsyncThunk } from '@reduxjs/toolkit'
import { LOCAL_STORAGE } from 'app/commons/constants/localStorage.const'
import { IRequiredFTLConfig, IRequiredSetting } from 'app/interface/IConfig'
import coreApi from 'app/services/coreApi'
import settingApi from 'app/services/settingApi'

export const handleGetConfiguration = createAsyncThunk(
  'config/handleGetConfiguration',
  async (payload: { areaId: string; companyId: string }) => {
    try {
      const { areaId, companyId } = payload
      const area_id = areaId || localStorage.getItem(LOCAL_STORAGE.AREA_ID)
      const queryParam = { area_id } as any
      if (companyId) queryParam.company_id = companyId
      const result = await settingApi.getConfigSetting(queryParam)
      return { data: result }
    } catch (error) {
      console.debug('handleGetConfiguration ERROR', error)
    }
  }
)

export const handleGetFTLConfiguration = createAsyncThunk(
  'config/handleGetFTLConfiguration',
  async (data: IRequiredFTLConfig) => {
    try {
      const { countryCode, languageCode } = data
      const result = await settingApi.getServiceAreaByCountry(countryCode, languageCode)
      return result
    } catch (error) {
      console.debug('handleGetFTLConfiguration ERROR', error)
    }
  }
)

export const handleUpdateCustomerSetting = async (data: IRequiredSetting) => {
  try {
    await coreApi.updateCustomerSetting(data.params)
    data.cb()
  } catch (ex) {
    console.debug(ex)
  }
}
